import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { Dispatch, SetStateAction } from 'react';
import type { DocumentDirectoryType } from '@econtractor/types';
import EToolTip from 'components/others/EToolTip';

export type DocumentTypeFilter = 'all' | DocumentDirectoryType;

export const DOCUMENT_TYPE_FILTER_OPTIONS: DocumentTypeFilter[] = [
    'all',
    'contract',
    'invoice',
    'act',
    'other',
];

interface DocumentFilterTypeProps {
    filterType: DocumentTypeFilter;
    setFilterType: Dispatch<SetStateAction<DocumentTypeFilter>>;
}

const DocumentFilterType = ({ filterType, setFilterType }: DocumentFilterTypeProps) => {
    const { t } = useTranslation(['Document']);

    return (
        <EToolTip title={t('toolTypeFilter')}>
            <span className="d-inline-block">
                <Dropdown>
                    <Dropdown.Toggle
                        className="fs-14 px-2 ms-1"
                        size="sm"
                        variant={filterType === 'all' ? 'primary' : 'danger'}
                        id="dropdown-documents-filter"
                    >
                        <i className="bi bi-funnel fs-14 p-0"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {DOCUMENT_TYPE_FILTER_OPTIONS.map((option) => (
                            <Dropdown.Item
                                key={option}
                                onClick={(e) => {
                                    e.currentTarget.blur();
                                    setFilterType(option);
                                }}
                            >
                                <div className="me-2">
                                    <input
                                        type="radio"
                                        checked={filterType === option}
                                        onChange={() => null}
                                        className="form-check-input"
                                    />
                                </div>
                                {option === 'all' ? t('filterAll') : t(`documentTypes.${option}`)}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </span>
        </EToolTip>
    );
};

export default DocumentFilterType;
